import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  applet_type: fromDatatype.VarcharDatatypeInterface;
  applet_icon_file_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  vendor_guid: fromDatatype.GuidDataFieldInterface;
  store_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  mfa_enforced: boolean;
  mfa_status: fromDatatype.VarcharDatatypeInterface;
  app_login_mfa_guid: fromDatatype.GuidDataFieldInterface;
  default_language_guid: fromDatatype.GuidDataFieldInterface;
  default_language_code: fromDatatype.VarcharDatatypeInterface;
  documentation_url: fromDatatype.VarcharDatatypeInterface;
}


export class bl_applet_hdr_RowClass implements bl_applet_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  applet_type: fromDatatype.VarcharDatatypeInterface;
  applet_icon_file_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  vendor_guid: fromDatatype.GuidDataFieldInterface;
  store_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  mfa_enforced: boolean;
  mfa_status: fromDatatype.VarcharDatatypeInterface;
  app_login_mfa_guid: fromDatatype.GuidDataFieldInterface;
  default_language_guid: fromDatatype.GuidDataFieldInterface;
  default_language_code: fromDatatype.VarcharDatatypeInterface;
  documentation_url: fromDatatype.VarcharDatatypeInterface;
}
